{
  "name": "default",
  "_note": "기본값과 동일. 비교 기준점."
}
